import { VFlow } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import React from 'react'

import { CredenciaisIntegracaoBoxOld } from './credenciais-integracao_old/CredenciaisIntegracaoBoxOld'
import { TransmissaoHorarioGeracaoLotesBox } from './horarioGeracaoLotes/TransmissaoHorarioGeracaoLotesBox'
import { TransmissaoLinksDestinoBox } from './instalacoesDestino/TransmissaoLinksDestinoBox'

export function TransmissaoConfiguracoesGeralView() {
  const { PILOTO_INTEGRACAO_REGULACAO_ENABLED } = useFlags()

  return (
    <VFlow vSpacing={2}>
      <TransmissaoLinksDestinoBox />
      <TransmissaoHorarioGeracaoLotesBox />
      {!PILOTO_INTEGRACAO_REGULACAO_ENABLED && <CredenciaisIntegracaoBoxOld />}
    </VFlow>
  )
}
